export async function initArtistSections({
	grid,
	shapeForChar,
	getShapeFrames,
	shuffleArray,
	setStatus,
}) {
	if (!grid) {
		return { artistContainers: [], observer: null };
	}

	const sections = grid.querySelectorAll('.artist-section');
	if (sections.length === 0) {
		setStatus('No artists found.');
		return { artistContainers: [], observer: null };
	}

	setStatus('Loading drawings for all artists...');

	const allShapesNeeded = new Set();
	sections.forEach((section) => {
		const cells = section.querySelectorAll('.artist-cell');
		cells.forEach((cell) => {
			const char = cell.dataset.char || '';
			if (char.trim()) {
				allShapesNeeded.add(shapeForChar(char));
			}
		});
	});

	try {
		await Promise.all([...allShapesNeeded].map((shape) => getShapeFrames(shape)));
	} catch (error) {
		console.error('Failed to preload shapes:', error);
		setStatus('Failed to load drawings.');
		return { artistContainers: [], observer: null };
	}

	const artistContainers = [];
	for (const section of sections) {
		const cells = section.querySelectorAll('.artist-cell');
		const cellData = [];

		await Promise.all(
			[...cells].map(async (cell) => {
				const char = cell.dataset.char || '';
				const pathEl = cell.querySelector('path');
				if (!pathEl || !char.trim()) {
					return;
				}
				const shape = shapeForChar(char);
				const cachedFrames = await getShapeFrames(shape);
				const frames = shuffleArray(cachedFrames);
				pathEl.setAttribute('d', frames[0] || '');
				cellData.push({
					pathEl,
					frames,
					frameIndex: 0,
				});
			})
		);

		artistContainers.push({
			element: section,
			cells: cellData,
			isVisible: false,
		});
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const container = artistContainers.find((c) => c.element === entry.target);
				if (container) {
					container.isVisible = entry.isIntersecting;
				}
			});
		},
		{
			rootMargin: '200% 0px',
			threshold: 0,
		}
	);

	artistContainers.forEach((container) => {
		observer.observe(container.element);
	});

	const totalCells = artistContainers.reduce((sum, container) => sum + container.cells.length, 0);
	setStatus(`${sections.length} artists loaded (${totalCells} cells).`);

	return { artistContainers, observer };
}
